
export interface MarkAllAsReadResponse {
  updatedCount: number;
}
